import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';
export default (function (params) {
  let apiUrl = `/api/ipqc/inspection/main`;
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '/api/ipqc/inspection/main',
    name: 'IPQC_PROCESS_INSPECTION_GTE',
    method: 'GET'
  });
  useEffect(() => {
    if (params) {
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          apiUrl += '?';
        } else {
          apiUrl += '&';
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        apiUrl += `${key}=${params[key]}`;
      });
      exec(apiUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [data || [], isLoading, exec, isRequestSuccessed];
})